import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import {
  Row,
  Col,
  Container,
  DropdownItem,
  Input,
  FormGroup,
  Button
} from "reactstrap";

import { useVsiAppContext } from "../stores/VsiApp";
import { TopHeader } from "../styled/TopNav.styled";
import ClientSwitcher from "./ClientSwitcher";
import style from "../utils/themeStyles";
import VsiDropdown from "./VsiDropdown";
import { VsiLgText, VsiSmallText } from "../styled/App.styled";
import VOILogo from "../assets/images/VOILogo";

import { useAuth0 } from "@auth0/auth0-react";

export default function TopNav() {
  const { theme, toggleTheme, isTabletScreen, periods, user, setPeriodId, periodId, setPeriodDate, isGettingPeriods, doPeriodsMatchReportContext } = useVsiAppContext();
  const { logout } = useAuth0();

  const [isUserOpen, setUserOpen] = useState(false);
  const [datesOpen, setDatesOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isDarkChecked, setIsDarkChecked] = useState(theme === "dark");
  const [availableDates, setAvailableDates] = useState([]);
  const [datesValue, setDatesValue] = useState(null);

  const history = useLocation();
  const usesDates = history.pathname.startsWith("/reports");


  let navigate = useNavigate();

  useEffect(() => {
    setIsDarkChecked(theme === "dark");
  }, [theme]);

  const toggleDatesOpen = () => setDatesOpen((prevState) => !prevState);

  useEffect(() => {
    if (periods) {
      let activeDate = null;
      let activePeriod = null;
      const datesRange = periods?.map((dateObj) => {
        let splits = dateObj.collection_date.split("-");
        let splitDay = splits[2].split("T");
        let day = splitDay[0];
        const dateInPlay = `${splits[1]}/${day}/${splits[0]}`;
        if (parseInt(dateObj.period_id) === parseInt(periodId)) {
          activeDate = dateInPlay;
          activePeriod = parseInt(dateObj.period_id);
        }
        return dateInPlay;
      });
      setAvailableDates(datesRange || []);
      if (!datesValue || activePeriod !== periodId || activeDate !== datesValue) {
        if (periodId && activeDate) {
          setDatesValue(activeDate);
        } else {
          setDatesValue(datesRange?.[0]);
        }
      }
    }
  }, [periods, datesValue, periodId]);


  const accessProfile = () => {
    navigate(`/user/profile`);
  };

  const dateClick = (event) => {
    const formattedDate = event.target.innerHTML;
    if (periods.length === 0) return;
    let chosenPeriod = periods.find((dateData) => {
      let splits = dateData.collection_date.split("-");
      let splitDay = splits[2].split("T");
      let day = splitDay[0];
      let chosenDate = `${splits[1]}/${day}/${splits[0]}`;
      return chosenDate === formattedDate;
    });

    searchParams.set("period_id", chosenPeriod.period_id);
    setSearchParams(searchParams);
    setDatesValue(formattedDate);
    setPeriodDate(formattedDate)
    setPeriodId(chosenPeriod.period_id);
  };

  const { role } = user;
  const multiClientRoles = ["super_user", "super_user_read_only"];

  const clientSwitcher = multiClientRoles.includes(role) ? (
    <ClientSwitcher />
  ) : null;

  const autobotButton = (
    <div
      className={
        "d-flex flex-column align-items-start justify-content-end h-100 ms-2"
      }
    >
      {isTabletScreen ? null : (
        <VsiSmallText className={"mb-1"} $textAlign={"left"}>
          Custom Email:
        </VsiSmallText>
      )}
      <Button
        outline
        // disabled={true}
        onClick={() => navigate(`/user/settings/admin/autobot`)}
      >
        <i id="autobotEmail" className="fa-solid fa-envelope" />
        {isTabletScreen ? null : " Generate"}
      </Button>
    </div>
  );

  return (
    <TopHeader>
      <Container fluid>
        <Row>
          <Col
            xs={9}
            className={`d-flex flex-row justify-content-start align-items-center`}
          >
            <VOILogo
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/home")}
            />
            {
              <div
                style={{ border: "none" }}
                className={
                  !isTabletScreen
                    ? `input-selector-${theme} ms-4 me-2`
                    : `input-selector-${theme} ms-2 me-1`
                }
              >
                {usesDates ? (
                  <>
                    {isTabletScreen ? null : (
                      <VsiSmallText>Collection Date:</VsiSmallText>
                    )}
                    <VsiDropdown
                      toggle={toggleDatesOpen}
                      direction={"down"}
                      isOpen={datesOpen}
                      caret
                      end
                      toggleStyle={{
                        backgroundColor: style[theme].selectorBg,
                        color: style[theme].textColor
                      }}
                      toggleValPrefix={
                        <i className="fa-solid fa-calendar-days me-1" />
                      }
                      toggleVal={datesValue}
                      dark={theme === "dark"}
                      loading={isGettingPeriods && !doPeriodsMatchReportContext}
                      disabled={isGettingPeriods && !doPeriodsMatchReportContext}
                      dropdownMenuStyle={{
                        overflowY: "scroll",
                        maxHeight: "400px",
                        backgroundColor: style[theme].selectorBg
                      }}
                    >
                      {availableDates.map((date) => {
                        return (
                          <DropdownItem
                            key={`${date}`}
                            onClick={dateClick}
                            style={{ color: style[theme].textColor }}
                          >
                            {date}
                          </DropdownItem>
                        );
                      })}
                    </VsiDropdown>
                  </>
                ) : null}
              </div>
            }
            {clientSwitcher}
            {autobotButton}
          </Col>
          <Col
            xs={3}
            className={`d-flex flex-row justify-content-end align-items-center`}
          >
            <VsiDropdown
              inNavbar
              toggle={() => setUserOpen(!isUserOpen)}
              direction={"down"}
              tag="span"
              isOpen={isUserOpen}
              toggleStyle={{
                backgroundColor: "transparent",
                border: "unset",
                color: style[theme].textColor,
                cursor: "pointer"
              }}
              caret
              end
              toggleVal={
                isTabletScreen ? (
                  <>
                    <i className={`fa fa-user`} />
                  </>
                ) : (
                  <>
                    <VsiLgText>
                      {user.firstName} {user.lastName}
                    </VsiLgText>
                  </>
                )
              }
              dark={theme === "dark"}
            >
              <DropdownItem
                name="dark"
                toggle={false}
                className={
                  "d-flex flex-row align-items-center justify-content-between"
                }
                onClick={(e) => {
                  e.preventDefault();
                  toggleTheme(theme === "light" ? "dark" : "light");
                }}
              >
                <>
                  <i className={`fa-solid fa-sun`} />
                  <FormGroup
                    switch
                    className={"d-flex flex-row justify-content-center w-100"}
                  >
                    <Input
                      type={"switch"}
                      role={"switch"}
                      style={{
                        cursor: "pointer"
                      }}
                      onChange={() => {
                      }}
                      checked={isDarkChecked}
                    />
                  </FormGroup>
                  <i className={`fa-solid fa-moon`} />
                </>
              </DropdownItem>

              <DropdownItem divider />
              <DropdownItem
                className={
                  "d-flex flex-row align-items-center justify-content-between"
                }
                onClick={accessProfile}
              >
                <i className={"fa fa-user"} />
                {"My Profile"}
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem
                className={
                  "d-flex flex-row align-items-center justify-content-between"
                }
                id="logoutButton"
                onClick={logout}
              >
                <i className={"fa fa-hand-wave"} />
                {"Logout"}
              </DropdownItem>
            </VsiDropdown>
          </Col>
        </Row>
      </Container>
    </TopHeader>
  );
}
